<template>
  <!--  <v-chip group v-model="internalValue" mandatory>-->
  <div class="d-flex flex-wrap" style="transition: all 1s ease-in-out">
    <div
      class="ma-2 pa-1 d-flex"
      :class="internalValue === state.id ? 'selected-state' : 'unselected-state'"
      v-for="state in states"
      :key="state.id"
      @click="selectState(state)"
      :style="{ border: `${state.bgColor} 2px solid`, color: 'white', cursor: disabledSystemValues.includes(state.systemValue) ? 'not-allowed' : '' }"
    >
      <div
        class="pa-2"
        :style="{
          background: state.bgColor,
          borderRadius: '8px',
          transition: 'width 1s ease-in-out',
          color: 'white',
          cursor: disabledSystemValues.includes(state.systemValue) ? 'not-allowed' : '',
        }"
      >
        <v-icon v-if="internalValue === state.id" small color="white">mdi-checkbox-marked-circle</v-icon> {{ state.text }}
      </div>
    </div>
  </div>
  <!--  </v-chip>-->
</template>
<script>
export default {
  name: 'StatePicker',
  props: {
    statesById: Object,
    value: Number,
  },
  data() {
    return {
      internalValue: this.value,
      disabledSystemValues: ['forwarded', 'returnedAndOpen', 'returnedToAuthor'],
    };
  },
  computed: {
    states() {
      return Object.keys(this.statesById)
        .map((key) => this.statesById[key])
        .sort((a, b) => (a.id - b.id ? 1 : -1));
    },
  },
  methods: {
    selectState(state) {
      if (this.disabledSystemValues.includes(state.systemValue)) {
        return;
      } else if (this.internalValue === state.id) {
        this.internalValue = null;
      } else {
        this.internalValue = state.id;
      }
    },
  },
  watch: {
    internalValue(newValue, oldValue) {
      this.$emit('input', newValue);
    },
    value(newValue, oldValue) {
      this.internalValue = newValue;
    },
  },
};
</script>
<style scoped>
.selected-state,
.unselected-state {
  border-radius: 10px;
  width: fit-content;
}
.selected-state {
  /**border: 6px solid grey !important;**/
}
.unselected-state {
  border: 2px solid transparent !important;
}
</style>
